import { render, staticRenderFns } from "./DeliveryProfileZones.vue?vue&type=template&id=e28473a8&"
import script from "./DeliveryProfileZones.vue?vue&type=script&lang=ts&"
export * from "./DeliveryProfileZones.vue?vue&type=script&lang=ts&"
import style0 from "./DeliveryProfileZones.vue?vue&type=style&index=0&id=e28473a8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports